const cjdr = {
  state: () => ({
    images: {
      sedans: [
        {
          modelName: "Chrysler 300",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2022_chrysler_300.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/2022_chrysler_300.png"),
          trims: ["Touring", "Touring L", "300S V6", "300S V8"]
        },
        {
          modelName: "Dodge Charger",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2022_dodge-charger.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/2022_dodge-charger.png"),
          trims: ["SXT", "GT", "Scat Pack", "SRT Hellcat Redeye Jailbreak", "RT", "Scat Pack Widebody", "SRT Hellcat Widebody Jailbreak",]
        },
        {
          modelName: "Dodge Challenger",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2022_dodge-challenger.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/2022_dodge-challenger.png"),
          trims: ["SXT", "GT", "R/T", "R/T Scat Pack", "R/T Scat Pack Widebody", "SRT Hellcat Jailbreak", "SRT Hellcat Widebody Jailbreak", "SRT Hellcat Redeye Jailbreak", "SRT Hellcat Redeye Widebody Jailbreak", "SRT Super Stock"]
        }
      ],
      suvs: [
        {
          modelName: "Chrysler Pacifica",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2022_chrysler-pacifica.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/2022_chrysler-pacifica.png"),
          trims: ["Touring", "Touring L", "Limited", "Pinnacle"]
        },
        {
          modelName: "Jeep Grand Cherokee",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2023_jeep-grand-cherokee.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/2023_jeep-grand-cherokee.png"),
          trims: ["Laredo", "Altitude", "Limited", "Overland", "Summit", "Summit Reserve"]
        },
        {
          modelName: "Jeep Compass",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2022_jeep-compass.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/2022_jeep-compass.png"),
          trims: ["Latitude Lux", "Sport", "Latitude", "Limited", "Trailhawk", "(Red)", "Altitude", "High Altitude"]
        },
        {
          modelName: "Jeep Cherokee",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2022_jeep-cherokee.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/2022_jeep-cherokee.png"),
          trims: ["Altitude Lux", "Trailhawk"]
        },
        {
          modelName: "Jeep Renegade",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2023_jeep-renegade.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/2023_jeep-renegade.png"),
          trims: ["Latitude", "Upland", "Altitude", "Limited", "Trailhawk"]
        },
        {
          modelName: "Jeep Wrangler",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2022_jeep-wrangler.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/2022_jeep-wrangler.png"),
          trims: ["Sport", "Willys Sport", "Sport S", "Freedom", "Willys", "Sport Altitude", "Rubicon", "Sahara", "Sport RHD", "Sahara Altitude", "High Altitude", "Rubicon 392"]
        },
        {
          modelName: "Dodge Durango",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2022_dodge-durango.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/2022_dodge-durango.png"),
          trims: ["SXT", "GT", "R/T", "R/T Hemi Orange", "Citadel", "SRT 392", "SRT Hellcat"]
        },
        {
          modelName: "Dodge Hornet",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2023_dodge-hornet.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/2023_dodge-hornet.png"),
          trims: ["GT Plus", "GT"]
        }
      ],
      trucks: [
        {
          modelName: "Jeep Gladiator",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2023_jeep-gladiator.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/2023_jeep-gladiator.png"),
          trims: ["Sport", "Willys Sport", "Sport S", "Willys", "Freedom", "Overland", "Mojave", "Sahara", "Rubicon", "High Altitude"]
        },
        {
          modelName: "RAM 1500",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2022_ram-1500.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/2022_ram-1500.png"),
          trims: ["Limited", "Limited Longhorn", "Rebel", "Laramie", "Tradesman", "Tradesman HFE", "TRX"]
        },
        {
          modelName: "RAM 2500",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2022_ram-2500.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/2022_ram-2500.png"),
          trims: ["Tradesman", "Big Horn", "Laramie", "Power Wagon", "Limited Longhorn", "Limited"]
        }
      ],
      lifestyleImages: {
        defaultImage: require("../../../static/images/carcuts/cjdr/lifestyle/2023_jeep-gladiator-01.jpg"),
        sedanImage: require("../../../static/images/carcuts/cjdr/lifestyle/2023_chrysler-300s-01.jpg"),
        suvImage: require("../../../static/images/carcuts/cjdr/lifestyle/2022_dodge-durango-01.jpg"),
        truckImage: require("../../../static/images/carcuts/cjdr/lifestyle/2023_ram-2500-01.jpg")
      },
      videoLink: ["https://player.vimeo.com/progressive_redirect/playback/1008061807/rendition/720p/file.mp4?loc=external&signature=2b77dd4e620080907f3dc47148d5c2521fb43ceba21441af774ab8ce38272ea0"],
      roundButtons: [
        require("../../../static/images/buttons/round-buttons/chevy-New.png"), require("../../../static/images/buttons/round-buttons/chevy-Used.png"), require("../../../static/images/buttons/round-buttons/chevy-ScheduleService.png"), require("../../../static/images/buttons/round-buttons/chevy-Worth.png")
      ],
      browseButtons: [
        require("../../../static/images/buttons/browse-buttons/black-new.png"), require("../../../static/images/buttons/browse-buttons/black-used.png"), require("../../../static/images/buttons/browse-buttons/black-service.png"), require("../../../static/images/buttons/browse-buttons/black-specials.png")
      ],
      swoopIcons: [
        require("../../../static/images/buttons/swoop-icons/black01.png"), require("../../../static/images/buttons/swoop-icons/black03.png"), require("../../../static/images/buttons/swoop-icons/black02.png")
      ],
      homeBanners: [
        require("../../../static/images/banners/cjdr/CM-BS-24-CJDR-Established.jpg"), require("../../../static/images/banners/cjdr/CM-BS-24-CJDR-lifestyle.jpg"), require("../../../static/images/banners/cjdr/CM-BS-24-CJDR-Modern.jpg"), require("../../../static/images/banners/cjdr/CM-BS-24-CJDR-Playful.jpg")
      ],
      stripBanners: [
        require("../../../static/images/banners/cjdr/SOKAL-SRS-120921-Ram1500-Established.jpeg"), require("../../../static/images/banners/cjdr/SOKAL-SRS-120921-Ram1500-Lifestyle.jpeg"), require("../../../static/images/banners/cjdr/SOKAL-SRS-120921-Ram1500-Modern.jpeg"), require("../../../static/images/banners/cjdr/SOKAL-SRS-120921-Ram1500-Playful.jpeg")
      ],
      logoExample: [
        require("../../../static/images/buttons/logos/dd-logo-cjdr.png"),
        require("../../../static/images/buttons/logos/dd-logo-mistu-w.png")
      ]
    },
   colors: {
      "--primary-color": "#adafb2",
      "--primary-dark": "#000",
      "--primary-light": "#FFF",
      "--secondary-color": "#ff0000",
      "--secondary-dark": "#000",
      "--secondary-light": "#fff",
    },
    fonts: {
      "--heading-text": "'Roboto', 'Helvetica Neue', Arial, sans-serif",
      "--subheading-text": "'Roboto', 'Helvetica Neue', Arial, sans-serif",
      "--body-text": "'Roboto', 'Helvetica Neue', Arial, sans-serif",
      "--bold-text": "'Roboto', 'Helvetica Neue', Arial, sans-serif"
    }
  })
}


export default cjdr